import React from 'react';
import { connect } from 'react-redux';
import ShopTheCapsule from './components/ShopTheCapsule';
import ShopTheLook from './components/ShopTheLook';
import BrandDescription from './components/BrandDescription';
import PriceBreakUp from './components/PriceBreakUp';
import SimilarStyles from './components/SimilarStyles';
import CrossSell from './components/CrossSell';
import ProductRating from './components/ProductRating';
import StoreLinks from './components/StoreLinks';
import RecentlyViewed from './components/RecentlyViewed';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { signInCheck } from '../../common/CheckUserStatus';
import * as actions from '../../../actions/productData';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import {
  getAggregateRating,
  getSubRatings,
  getTextReview,
  getImageReview
} from '../../../refresh/selectors/productpage';
import {
  getShowRateProdBtn,
  getEnableRating,
  getShowSimilarProducts,
  getEnableCrossSell
} from '../../../refresh/selectors/featureFlagsSelector';
import { getVariant, getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import RatingHalfCard from '../../../refresh/organism/RatingHalfCard';

class ProductComponents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      productIds: []
    };
  }

  luxeEventPush = ({ eventName, ...rest }) => {
    const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    let eventPushObj = {
      user_details: {
        store_type: 'luxe',
        user_status: signInCheck() ? 'logged in' : 'not logged In',
        time_of_the_day: '',
        login_type: signInCheck() ? 'logged in' : 'not logged In',
        screen_name: screenName,
        screen_type: screenType
      }
    };
    gtmEventPush({
      event: eventName,
      ...rest,
      ...eventPushObj.user_details
    });
  };

  componentDidMount() {
    let { recentlyViewed } = this.props;
    let recentViewedProductIds = [];

    if (recentlyViewed?.length > 0) {
      recentViewedProductIds = recentlyViewed.map(element => element.id);
    }
    this.setState({ productIds: recentViewedProductIds });
  }

  render() {
    let {
      aggregateRating,
      subRatings,
      enableRating,
      recentlyViewed,
      showSimilarItems = false,
      showCrossSellWidget = false,
      showRateProdBtn,
      textReviews,
      imageReview
    } = this.props;
    let { productIds: productIDS = [] } = this.state;

    let { productData: product = {} } = this.props;
    let {
      code: productCode,
      isShopTheLookAvailable = '',
      fnlColorVariantData = {},
      storelinks = false,
      rilfnlBreadCrumbList = {},
      brickCode: brickVal
    } = product;
    const { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
    const brickName = rilfnlBreadCrumb[2] ? rilfnlBreadCrumb[2].name : '';
    const newDesignLuxe = this.props.newDesignLuxe;
    let productIds;
    productIds = productIDS.filter(e => e !== productCode);
    productIds = productIDS.toString();
    let brandDetails = [];
    if (fnlColorVariantData.catDescription) {
      const {
        catDescription = '',
        aboutBrandImgUrl = '',
        brandName = '',
        categoryUrl = ''
      } = fnlColorVariantData;
      brandDetails.push({
        brandName,
        aboutBrandImgUrl,
        catDescription,
        categoryUrl
      });
    }
    return (
      <div id="productPageRatingModal">
        <PriceBreakUp />
        {enableRating &&
          (aggregateRating?.averageRating ||
            (!aggregateRating?.averageRating &&
              getFeatureVariant('showRateProdBtnSection') === '1')) && (
            <ProductRating
              data={product}
              aggregateRating={aggregateRating}
              subRatings={subRatings?.subratings}
              customerWords={subRatings?.customerWord}
              textReviews={textReviews}
              imageReview={imageReview}
            />
          )}
        {brandDetails.length > 0 && (
          <BrandDescription brandDetails={brandDetails} newDesignLuxe={newDesignLuxe} />
        )}
        {brickName != '' && brickName != undefined && storelinks == true && (
          <StoreLinks data={product} newDesignLuxe={newDesignLuxe} />
        )}
        {isShopTheLookAvailable && <ShopTheLook productCode={productCode} />}

        { showCrossSellWidget && <Feature featureName="enable_urgency_driver_pdp">
          <Variant id="0">
            <CrossSell
             productIds={productIds}
             productCode={productCode}
             brickVal = {brickVal}
             productData={product}
             isNewProductTag={false}
            />
          </Variant>
          <Variant id="1">
            <CrossSell
           productIds={productIds}
           productCode={productCode}
           brickVal = {brickVal}
           productData={product}
           isNewProductTag
            />
          </Variant>
        </Feature>}
        
        <Feature featureName="enable_urgency_driver_pdp">
          <Variant id="0">
            <SimilarStyles
              productCode={productCode}
              productData={product}
              newDesignLuxe={newDesignLuxe}
              luxeEventPush={this.luxeEventPush}
              isNewProductTag={false}
              showSimilarItems={showSimilarItems}
            />
          </Variant>
          <Variant id="1">
            <SimilarStyles
              productCode={productCode}
              productData={product}
              newDesignLuxe={newDesignLuxe}
              luxeEventPush={this.luxeEventPush}
              isNewProductTag
              showSimilarItems={showSimilarItems}
            />
          </Variant>
        </Feature>
        {/* <ShopTheCapsule productCode={productCode} /> */}
        {productIds && (
          <Feature featureName="enable_urgency_driver_pdp">
            <Variant id="0">
              <RecentlyViewed
                productIds={productIds}
                recentlyViewedList={recentlyViewed}
                productData={product}
                newDesignLuxe={newDesignLuxe}
                luxeEventPush={this.luxeEventPush}
                isNewProductTag={false}
              />
            </Variant>
            <Variant id="1">
              <RecentlyViewed
                productIds={productIds}
                recentlyViewedList={recentlyViewed}
                productData={product}
                newDesignLuxe={newDesignLuxe}
                luxeEventPush={this.luxeEventPush}
                isNewProductTag
              />
            </Variant>
          </Feature>
        )}
        <RatingHalfCard />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const showSimilarItems = getShowSimilarProducts(state, 'WEB', 'PDP');
  return {
    aggregateRating: getAggregateRating(state),
    subRatings: getSubRatings(state),
    textReviews: getTextReview(state),
    imageReview: getImageReview(state),
    enableRating: getEnableRating(state?.flags,state),
    recentlyViewed: state?.recentlyViewed?.recent || [],
    showCrossSellWidget: getEnableCrossSell(state?.flags),
    showSimilarItems: showSimilarItems || false,
    showRateProdBtn: getShowRateProdBtn(state?.flags)
  };
};

export default ProductComponents = connect(mapStateToProps)(ProductComponents);
